import { Component } from '@angular/core';
import { Chart, registerables } from 'chart.js';

@Component({
  selector: 'chart-bar',
  standalone: true,
  imports: [],
  templateUrl: './bar.component.html',
  styleUrl: './bar.component.scss'
})
export class BarComponent {
  chart: any = [];

  constructor(){}

  ngOnInit() {
    Chart.register(...registerables);
    this.chart = new Chart('canvasBar', {
      type: 'bar',
      data: {
        labels: ['A', 'B', 'C', 'D', 'E', 'V', 'F'],
        datasets: [
          {
            label: 'Mais Marcadas Pelos Alunos',
            data: [12, 19, 10, 25, 15, 30, 20], // Dados para as barras
            backgroundColor: 'rgba(255, 255, 0, 0.2)', // Cor das barras (amarelo claro)
            borderColor: '#F2AE30', // Cor da borda das barras (amarelo sólido)
            borderWidth: 1,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });
  }
}
